module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.df7217e.woff2";